import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-stone-400 py-8 px-4 text-center border-t-8 border-amber" data-id="element-24">
      <div className="max-w-4xl mx-auto font-body text-sm" data-id="element-25">
        <p className="mb-2 font-heading font-bold text-xl text-stone-300 uppercase tracking-wider" data-id="element-26">
          Manual del Contratista Pro
        </p>
        <p className="mb-4" data-id="element-27">
          Hecho para los que ponen el lomo en la obra todos los días.
        </p>
        <p className="text-stone-600" data-id="element-28">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}